export const MeetingType = {
    "PARTYMEMBER": '1001',
    "PARTYBRANCH": '1002',
    "PARTYGROUP": '1003',
    "ZHIBU": '1004',
    "MINZHU": '1005'
}
